import i18n from 'services/base/i18n';

export default {
  // Button to delete the account
  delete: () => i18n.pgettext('Pages|Accounts|Delete Account', 'DELETE ACCOUNT'),
  // Label for the input box where the user inputs password
  password: () => i18n.pgettext('Pages|Accounts|Delete Account', 'ENTER PASSWORD'),
  // Label above the warning message about what happens when a user's account is deleted
  title: () => i18n.pgettext('Pages|Accounts|Delete Account', 'WARNING'),
  // Warning for the user on what happens when their account is deleted
  text: () => i18n.pgettext('Pages|Accounts|Delete Account', 'This will erase all of your data and settings in your Pangolins and in our servers. This CANNOT be undone.'),
};
